type CustomBorderIconProps = React.SVGProps<SVGSVGElement> & {
    style?: React.CSSProperties
}

const BorderInnerIcon = ({ style = {}, ...otherProps }: CustomBorderIconProps) => (
    <svg
        width='20'
        height='20'
        viewBox='0 0 257 257'
        fill='currentColor'
        style={{
            display: 'inline-block',
            flexShrink: 0,
            ...style
        }}
        {...otherProps}>
        <rect className='st0' x='74.97' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='74.97' y='32.12' width='21.42' height='21.42' />
        <rect className='st0' x='160.63' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='160.63' y='32.12' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='160.61' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='32.12' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='74.96' width='21.42' height='21.42' />
        <rect className='st0' x='32.15' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='32.15' y='160.61' width='21.42' height='21.42' />
        <rect className='st0' x='32.15' y='32.12' width='21.42' height='21.42' />
        <rect className='st0' x='32.15' y='74.96' width='21.42' height='21.42' />
        <path className='st0' d='M214.16,117.79h-74.95V42.83c0-5.89-4.82-10.71-10.71-10.71s-10.71,4.82-10.71,10.71v74.96H42.84c-5.89,0-10.71,4.82-10.71,10.71s4.82,10.71,10.71,10.71h74.95v74.96c0,5.89,4.82,10.71,10.71,10.71s10.71-4.82,10.71-10.71v-74.96h74.95c5.89,0,10.71-4.82,10.71-10.71s-4.82-10.71-10.71-10.71Z' />
    </svg>
)

export default BorderInnerIcon
